require('./bootstrap');

import Vue from 'vue';
window.Vue = require('vue');

// Observe Visibility
require('intersection-observer');
import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

// QR Code
import VueQRCodeComponent from 'vue-qrcode-component';
// Vue events
import VueEvents from 'vue-events';
// Vue Analytics
import VueAnalytics from 'vue-analytics'

//DatePicker
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
const datepickerOptions = {};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

// Carousel
import VueCarousel from '@chenfengyuan/vue-carousel';
Vue.use(VueCarousel);

// Translation
import VueInternationalization from 'vue-i18n';
import Locale from './vue-i18n-locales.generated';
Vue.use(VueInternationalization);
const lang = document.documentElement.lang;
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale
});

Vue.component('qr-code', VueQRCodeComponent);

Vue.use(VueEvents);

Vue.use(VueAnalytics, {
    id: 'UA-115474039-1',
    ecommerce: {
        enabled: true
    }
});

// Vue.component('mobile-overlay', require('./components/MobileOverlay.vue'));
Vue.component('appstore-redirect', require('./components/AppstoreRedirect.vue').default);
Vue.component('book-now-button', require('./components/BookNowButton.vue').default);
Vue.component('product-bottom-bar', require('./components/ProductBottomBar.vue').default);
Vue.component('image-loader', require('./components/ImageLoader.vue').default);
Vue.component('fx-step', require('./components/FxStep.vue').default);
Vue.component('download-app-button', require('./components/DownloadAppButton.vue').default);
Vue.component('download-app-container', require('./components/DownloadAppContainer.vue').default);
Vue.component('travel-sims-country-search-input', require('./components/TravelSimsCountrySearchInput.vue').default);
Vue.component('travel-sim-checkout',require('./components/TravelSimCheckOut.vue').default);
Vue.component('checkout-success', require('./components/CheckOutSuccess.vue').default);
Vue.component('currency-picker', require('./components/CurrencyPicker.vue').default);
Vue.component('language-picker',require('./components/LanguagePicker.vue').default);
Vue.component('travel-activities-search-input',require('./components/TravelActivitiesSearchInput').default);
Vue.component('travel-activity-product-card',require('./components/TravelActivityProductCard').default);
Vue.component('fanfare-countdown-timer',require('./components/FanfareCountDownTimer').default);
Vue.component('hotel-search-input',require('./components/HotelSearchInput').default);
Vue.component('insurance-step',require('./components/InsuranceStep').default);
Vue.component('payme-qr-code', require('./components/PayMeQrCode').default);
Vue.component('payme-checkout', require('./components/PayMeCheckout').default);
Vue.component('travel-activities-filter-container',require('./components/TravelActivitiesFilterContainer').default);
Vue.component('travel-activities-filter-button',require('./components/TravelActivitiesFilterButton').default);
Vue.component('checkout',require('./components/CheckOut').default);
Vue.component('travel-product-option-select',require('./components/TravelProductOptionSelect').default);
Vue.component('travel-insurance-search-bar',require('./components/TravelInsuranceSearchBar').default);
Vue.component('travel-product-image-slider',require('./components/TravelProductImageSlider').default);
Vue.component('travel-money-search-bar',require('./components/TravelMoneySearchBar').default);
Vue.component('download-app-pop-up-button',require('./components/DownloadAppPopUpButton').default);
Vue.component('download-app-pop-up-container',require('./components/DownloadAppPopUpContainer').default);


const app = new Vue({
    el: '#app',
    i18n
});
